<!--
 * @Description:潜在客户
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-03-13 14:22:49
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectChange }"
        serials
        :columns="columns"
        tableId="CustomerAggregation"
        @fetch="fetch"
        @mask="showMask"
        @search="clearParams"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="content" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="cosCenterCode" label="集团客户代码">
              <a-input v-model:value="queryForm.cosCenterCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="mdmCode" label="MDM客户编号">
              <a-input v-model:value="queryForm.mdmCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="brand" label="所属品牌">
              <a-select
                v-model:value="queryForm.brand"
                allowClear
                placeholder="请选择"
                :options="dataConfig.brandEnum"
              />
            </dc-form-item>
            <dc-form-item name="cusContractSubject" label="签约主体">
              <a-input v-model:value="queryForm.cusContractSubject" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="appId" label="所属组织">
              <a-select v-model:value="queryForm.appId" allowClear placeholder="请选择" :options="dataConfig.orgEnum" />
            </dc-form-item>
            <dc-form-item name="sys" label="业务系统">
              <a-select v-model:value="queryForm.sys" allowClear placeholder="请选择" :options="dataConfig.sysEnum" />
            </dc-form-item>
            <dc-form-item name="content" label="客户代码">
              <a-input v-model:value="queryForm.customerCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="contactName" label="联系人">
              <a-input v-model:value="queryForm.contactName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="contactMobile" label="手机号">
              <a-input v-model:value="queryForm.contactMobile" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="成交时间">
              <cos-range-picker v-model:startTime="queryForm.dealTimeStart" v-model:endTime="queryForm.dealTimeEnd" />
            </dc-form-item>
            <dc-form-item label="是否与其他客户合并">
              <a-select
                v-model:value="queryForm.mergeFlag"
                allowClear
                placeholder="请选择"
                :options="dataConfig.mergeFlag"
              />
            </dc-form-item>
            <dc-form-item name="seller" label="客户负责人">
              <user-select v-model:value="queryForm.seller" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'appId'">
            <p>
              {{
                text
                  ? text
                      .split(',')
                      .map((k) => orgEnumJson[k] || k)
                      .join(',')
                  : '--'
              }}
            </p>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button
                type="link"
                v-permission="'customer_aggregation_unbind_btn'"
                @click="handleUnbind(record)"
                :disabled="record.mergeFlag === 1 ? false : true"
                >解绑</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <CosMergeButton
            v-permission="'customer_aggregation_merge_btn'"
            :data="selectedRows"
            appId="customer"
            @success="success"
            type="primary"
            >合并</CosMergeButton
          >
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { computed, onActivated, ref, onMounted } from 'vue'
import { customerAggregationList, customerUnmerge, getItemsBySensitize } from '@/api/customer/index'
import dataConfig from '@/views/customer/commonEnum/dataConfig'
import CosMergeButton from '@/components/CosMergeButton'
import { useRoute } from 'vue-router'
import { DcConfirm, DcMessage } from '@dc-platform/dc-components'
import type { CustomerAggregationItem } from '@/typings/api/customer'
import dayjs from 'dayjs'

const route = useRoute()
const tableRef = ref()
const orgEnumJson = {
  cos_fbu: '谷仓-销售管理',
  cos_ofbu: '谷仓-海外销售管理',
  cos_lbu: '云途-销售管理'
}
const selectedRows = ref<CustomerAggregationItem[]>([])
const masterCosCenterCode = ref('')
// const masterCosCenterArray = ref('')

const queryForm = ref<any>({})

// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  customerAggregationList({
    ...params,
    masterCosCenterCode: masterCosCenterCode.value
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: CustomerAggregationItem, callBack: (res: any) => void) => {
  getItemsBySensitize({
    cosId: record.cosId
  }).then((res) => {
    callBack(res.data)
  })
}
const clearParams = () => {
  localStorage.setItem('dc-cos-lbu-exclude-keep-alive', '')
  masterCosCenterCode.value = ''
}
// 清除缓存
const clearKeep = () => {
  const code = localStorage.getItem('dc-cos-lbu-exclude-keep-alive')
  if (code && code === route.query.masterCosCenterCode) {
    masterCosCenterCode.value = code
    queryForm.value = {}
    localStorage.removeItem('dc-cos-lbu-exclude-keep-alive')
  }
}
onMounted(() => {
  masterCosCenterCode.value = route.query.masterCosCenterCode as string
  if (!route.query.masterCosCenterCode) {
    queryForm.value.dealTimeStart = dayjs().subtract(30, 'day').format('YYYY/MM/DD 00:00:00')
    queryForm.value.dealTimeEnd = dayjs().format('YYYY/MM/DD 23:59:59')
  }
})
onActivated(() => {
  clearKeep()
})
// 合并客户
const onSelectChange = (selectedRowKeys: string[], rows: CustomerAggregationItem[]) => {
  selectedRows.value = rows
}
// 解绑
const handleUnbind = (row: CustomerAggregationItem) => {
  DcConfirm.warning({
    title: '解绑提示！',
    content: '是否解除绑定',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      customerUnmerge({
        masterCosCenterCodes: [row.masterCosCenterCode]
      }).then((res) => {
        DcMessage.success('解绑成功')
        success()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/customer/customerAggregation/view',
    query: ['cosId', 'status', 'appId'],
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '集团客户代码', dataIndex: 'cosCenterCode', width: 150 },
  { title: 'MDM客户编号', dataIndex: 'mdmCode', width: 150 },
  { title: '所属品牌', dataIndex: 'brand' },
  { title: '内部签约主体', dataIndex: 'ourContractSubject' },
  { title: '签约主体', dataIndex: 'cusContractSubject' },
  { title: '所属组织', dataIndex: 'appId', dicData: dataConfig.orgEnum },
  { title: '业务系统', dataIndex: 'sys', dicData: dataConfig.sysEnum },
  { title: '客户编号', dataIndex: 'customerNumber' },
  { title: '客户代码', dataIndex: 'customerCode' },
  { title: '客户类型', dataIndex: 'customerType', dicData: dataConfig.customerTypeEnum },
  {
    title: '冻结状态',
    dataIndex: 'freezeStatus',
    dicData: [
      { label: '正常', value: 1 },
      { label: '冻结', value: 2 }
    ]
  },
  { title: '联系人', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '成交时间', dataIndex: 'dealTime', width: 190 },
  { title: '客户状态', dataIndex: 'status', dicData: dataConfig.customerStatus },
  { title: '是否与其他客户合并', dataIndex: 'mergeFlag', dicData: dataConfig.mergeFlag, width: 150 },
  { title: '客户负责人', dataIndex: 'sellerName' },
  {
    title: '操作',
    dataIndex: 'action',
    width: 120,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosCustomerAggregation' }
</script>

<style scoped></style>
